module.exports = __webpack_public_path__ + "static/img/row8.0b59e6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/mobile/row8.png
// module id = B9Dp
// module chunks = 12